module.exports = __webpack_public_path__ + "static/Pfalz2-scaled-2135f921f04cf52f0449ff287d28c240.jpeg";